export default __webpack_public_path__ + "static/media/illustration-smart-600px.ac0ba4ef.svg";